import { render, staticRenderFns } from "./MonetariesTable.vue?vue&type=template&id=2b08e8cf&scoped=true&"
import script from "./MonetariesTable.vue?vue&type=script&lang=js&"
export * from "./MonetariesTable.vue?vue&type=script&lang=js&"
import style0 from "./MonetariesTable.vue?vue&type=style&index=0&id=2b08e8cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b08e8cf",
  null
  
)

export default component.exports